<template>
  <div class="page">
    <Header title="激活账号"></Header>
    <ActivationStep></ActivationStep>
    <div class="content">
        <div class="register_action" ng-if="rule==='SAH'">
            <p class="txt-indent2">欢迎您使用博世电动工具易加积分兑换网站（以下简称“本网站”），本网站所提供的各项服务的所有权和运作权归博世电动工具（中国）有限公司所有。请您在使用本网站的所有服务前，仔细阅读《博世电动工具易加积分兑换网站使用条款》（以下简称“本条款”）。您在同意本协议各项条款并完成账户激活程序后，才能成为本网站的正式客户并且使用本网站提供的相关服务。</p>

            <h1 class="clause-title">版权和商标</h1>
            <p class="txt-indent2">博世电动工具（中国）有限公司拥有本网站内所有内容（包括但不限于：文字、图片、软件、图形、音像及声音内容、Logo标识、版面设计、专栏目录与名称、商品分类等）的版权及本网站中涉及的任何其他知识产权。</p>
            <br>
            <p class="txt-indent2">本网站使用的www.pt.bosch-extra.com.cn和本网站的其他注册域名，以及“博世”、“BOSCH”、“extra”等注册商标均属本公司所有，受相关法律保护，未经本公司许可，任何单位及个人均不得将上述注册域名、注册商标进行容易引起混淆或歧义的使用。本网站其他产品服务名称，相关图形和标识均为本公司的专有标识，未经本公司许可，任何单位及个人不得以任何方式（包括但不限于：复制、转载、剪辑、摘编、传播、展示、镜像等）擅自使用。</p>
            <br>
            <p class="txt-indent2">以上属本公司拥有的所有内容未经授权，任何单位及个人不得用于商业、盈利、广告等目的，违反者将追究其法律责任。</p>

            <h1 class="clause-title">适用</h1>
            <p class="txt-indent2">本网站的服务仅面向与博世电动工具（中国）有限公司具有商业关系的博世经销商和分销商的所有者或授权者以及个人用户。您通过任何用户名在本网站上进行的一切操作（包括但不限于：登录、兑换、评论、资料修改申请等）均被视作您为该用户名所对应的公司所有者或授权者或者是该用户名对应的个人用户本人。您在本网站所兑换的礼品将为您公司或者个人所有。您在初次登录网站时将被要求确认公司或者个人资料的真实有效性。在这一过程和之后的使用中，您需要保持相关资料的更新。如果因公司或者个人资料不真实而造成的任何问题，由您本人和/或公司承担相应后果。</p>
            <br>
            <p class="txt-indent2">经您同意，本网站有权通过各种方式（包括但不限于页面广告、电子邮件、手机短信等）向您和/或公司投放各类产品或活动宣传信息，或是发送活动宣传品或其他相关资料。</p>
            <br>
            <p class="txt-indent2">您在使用本网站服务过程中，必须做到以下几点：</p>
            <p class="txt-indent2">1.遵守中国有关法律和法遵守所有与网站服务有关的协议、规定和程序，承诺遵循透明、公开原则，并根据相关中国法律法规将兑换所得礼品如实记帐；</p>
            <p class="txt-indent2">2.不得为任何非法目的而使用本网站服务系统；</p>
            <p class="txt-indent2">3.不得利用本网站制作、复制和传播任何非法信息；</p>
            <p class="txt-indent2">4.不得以任何形式损害本网站的利益，包括但不限于发布未经本网站许可的商业广告；</p>
            <p class="txt-indent2">5.不得利用本网站服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
            <p class="txt-indent2">6.不得侵犯本网站及其他任何第三方的版权、商标权、专利权、及名誉权及其他任何合法权益；</p>
            <br>
            <p class="txt-indent2">本网站有权对您使用本网站的情况进行审查和监督，如果您在使用本网站时违反任何上述规定，本网站有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除相关内容等、暂停或终止您和/或您公司使用本网站的权利）以减轻您的不当行为所造成的影响。</p>

            <h1 class="clause-title">免责声明</h1>
            <h4 class="clause-subtitle">密码</h4>
            <p class="txt-indent2">请您妥善保管好您的用户名和密码，切勿将其转让或出借给其他人使用。如您发现账号遭盗用，应立即与本网站相关人员联系。如因您本人保管疏忽或黑客窃取账号及密码而造成的任何损失，本网站不承担任何责任。任何人不得盗用他人账号及密码，发现此类违法行为，本网站将依法处理，其后果自行承担。</p>

            <h4 class="clause-subtitle">网络</h4>
            <p class="txt-indent2">本网站不保证网络服务一定满足您的要求，不保证网络服务不中断，不保证网路服务的及时性、安全性、准确性。</p>
            <p class="txt-indent2">本网站保留随时修改或中断网络服务而不需知照客户的权利。因网络状况、通讯线路、不可抗力因素等本网站无法控制的原因而导致网络服务中断或其它缺陷，对其造成的损失和影响本网站不承担任何责任，但会采取必要措施尽力将损失和影响降至最低。</p>

            <h4 class="clause-subtitle">礼品兑换</h4>
            <p class="txt-indent2">请在收货时当场拆箱验货，尤其是对易碎品进行仔细检查。一旦您确认签收，司机和送货人员离开后，我们将不再接受除商品本身质量问题外其他原因的换货及退货。因客户自身原因导致礼品破碎、变质，由本人承担损失，本网站不承担任何责任。</p>

            <h4 class="clause-subtitle">积分</h4>
            <p class="txt-indent2">您的积分不得转让他人、不可兑换现金，并不具备任何财产性质，并非您拥有所有权的财产。本网站有权单方面调整积分或是修改或变更积分规则，如您继续使用本网站提供的积分兑换礼品服务，则视为您已经同意并将遵从调整后的积分以及修改后的积分规则。</p>

            <h4 class="clause-subtitle">手机号绑定</h4>
            <p class="txt-indent2">用户注册账号时将默认与您提供的促销负责人的手机绑定，用该手机号码登陆时可自助修改除客户号，客户名称及手机号以外的其他个人资料。若您更换促销负责人，或该负责人手机号码有变更，请及时联系客服进行更新，解除与原手机号码的绑定关系。若因您未主动及时取消绑定关系引起的所有后果，本公司将不承担任何法律责任。鉴于网络服务的特殊性，本公司无义务审核是否是您本人使用该手机及密码，本公司仅审核用户名及密码是否与数据库中保存的一致，任何人只要输入的用户名及密码与数据库中保存的一致，即可凭借该组用户名及密码登陆并获得本公司所提供的各类服务，所以即使您的账户登陆行为并非您本人所为，本公司将不承担因此而产生的任何责任。账号因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，本公司并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</p>

            <h4 class="clause-subtitle">隐私与安全</h4>
            <p class="txt-indent2">本网站承诺不对外公开或向第三方提供您的注册资料及使用网站服务时提供的非公开内容（公安机关要求协助调查等特殊情况除外）。</p>

            <h4 class="clause-subtitle">协议修改 </h4>
            <p class="txt-indent2">博世电动工具（中国）有限公司（以下简称“本公司”）负责本网站的日常运行和维护，拥有对本协议的修改权。本公司不定期地对本协议进行必要的修改，因此建议您经常查看条款内容。如您继续使用本网站提供的服务，则视为您同意并将遵从修改后的协议内容。</p>
            <p class="txt-indent2">本网站针对某些特定服务的使用通过网上公告、电子邮件、短信提醒等各种方式作出的相关声明、通知、警示等内容均视为本协议的一部分，请仔细阅读。如您继续使用本网站提供的相关服务，则视为您同意并遵从此类声明、通知、警示等内容。</p>
        </div>
    </div>
    <div class="activation_btn_box">
      <div class="btn agree_btn" @click="gotoWeb()">同意</div>
      <div class="btn disagree_btn" @click="handleDisagree()">不同意</div>
    </div>

  </div>
</template>

<script>
import Header from '@/components/header'
import ActivationStep from '@/components/activation-step'
import ssoLoginApi from '@/api/sso-login'
import { userUtils } from '@/utils/auth'
export default {
  components: {
    Header,
    ActivationStep
  },
  methods: {
    gotoWeb () {
      this.$router.push({ name: 'activation_step_two' })
    },
    handleDisagree () {
      this.$dialog.confirm({
        title: '提示',
        message: '如果不同意,则会退出登录!'
      })
        .then(() => {
          ssoLoginApi.authLogout().then(res => {
            userUtils.removeUserLocal()
            this.$router.push({ name: 'login2' })
          })
          // on confirm
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style scoped lang="less">
.page{
  width: 100%;
  height: calc(100vh - 46px);
  background-color: #fff;
}
.content{
  width: 90%;
  margin-left: 5%;
  background-color: rgb(247, 247, 247);
  border-radius: 5px;
  height: calc(100vh - 250px);
  overflow-y: scroll;
}
.clause-title{
    line-height: 1rem;
    font-size: 19px;
    font-weight: bold;
}
.clause-subtitle{
    line-height: 0.8rem;
    font-size: 16px;
    font-weight: bold;
}
.txt-indent2{
    text-indent: 2em;
}
.register_action{
  width: 90%;
  margin: 20px 5%;
}
</style>
